export default __webpack_public_path__ + "static/media/logo-sap.041bf697.svg";